import { Component, OnInit, Input } from '@angular/core';
import { FormGroupDirective, FormGroup, FormControl, ControlContainer, Validators } from '@angular/forms';
import { CompanyDetail } from '../../models/company-detail.model';
import { TariffDetail } from '../../models/tariff-detail.model';

@Component({
  selector: 'app-company-form',
  templateUrl: './company-form.component.html',
  styleUrls: ['./company-form.component.css'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class CompanyFormComponent implements OnInit {
  private _company: CompanyDetail;
  _tariffs: TariffDetail[];

  constructor(public parent: FormGroupDirective) {}

  ngOnInit() {
    const defaultTariffCode = this._tariffs[0].code;

    this.parent.form.addControl('company', new FormGroup({
      name: new FormControl('', Validators.required),
      ico: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]),
      tariff: new FormControl(defaultTariffCode, Validators.required),
    }));

    if (this._company) {
      this.parent.form.patchValue({
        company: {
          name: this._company.name,
          ico: this._company.ico,
          tariff: this._company.tariff.code
        }
      });
    }
  }

  @Input()
  set company(company: CompanyDetail) {
    this._company = company;
  }

  @Input()
  set tariffs(tariffs: TariffDetail[]) {
    this._tariffs = tariffs;
  }

}
